import { createSelector } from 'reselect';

const selectLeads = (state: any) => state.leads;

export const selectLeadsCurrentItem = createSelector([selectLeads], (leads) => leads.current);

export const selectLeadsListItems = createSelector([selectLeads], (leads) => leads.list);

export const selectLeadsItemById = (itemId: any) =>
    createSelector(selectLeadsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLeadsQueryItems = createSelector([selectLeads], (leads) => leads.query);

export const selectLeadsCreatedItem = createSelector([selectLeads], (leads) => leads.create);

export const selectLeadsUpdatedItem = createSelector([selectLeads], (leads) => leads.update);

export const selectLeadsReadItem = createSelector([selectLeads], (leads) => leads.read);

export const selectLeadsDeletedItem = createSelector([selectLeads], (leads) => leads.delete);

export const selectLeadsSearchedItems = createSelector([selectLeads], (leads) => leads.search);

export const selectLeadsItemsCount = createSelector([selectLeads], (leads) => leads.count);

export const selectLeadsItemsFilter = createSelector([selectLeads], (leads) => leads.filter);